/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Action creators for the app module
 */

import { createAction } from 'redux-actions'
import {
  APP_MOUNTED,
  HIDE_APP_DOWNLOAD_BAR,
  INITIAL_LOCATION_CHANGED,
  INITIAL_LOCATION_HAS_UTM_PARAMS,
  INIT_LOCAL_STORAGE,
  SET_BOT,
  SET_MOBILE,
  SET_ONLINE,
  SET_SENDING_MESSAGE,
  SET_SENDING_TOUR,
  SET_WARN_OFFLINE,
  SHOW_APP_DOWNLOAD_BAR,
  UPDATE_NOW,
} from '../constants/index'

export const appMounted = createAction(APP_MOUNTED)

export const hideAppDownloadBar = createAction(HIDE_APP_DOWNLOAD_BAR)
export const showAppDownloadBar = createAction(SHOW_APP_DOWNLOAD_BAR)

export const setBot = createAction<boolean, typeof SET_BOT>(SET_BOT)
export const setMobile = createAction<boolean, typeof SET_MOBILE>(SET_MOBILE)
export const setOnline = createAction<boolean, typeof SET_ONLINE>(SET_ONLINE)
export const setSendingMessage = createAction<boolean, typeof SET_SENDING_MESSAGE>(
  SET_SENDING_MESSAGE
)
export const setSendingTour = createAction<boolean, typeof SET_SENDING_TOUR>(SET_SENDING_TOUR)
export const setWarnOffline = createAction<boolean, typeof SET_WARN_OFFLINE>(SET_WARN_OFFLINE)

export const initLocalStorage = createAction(INIT_LOCAL_STORAGE)

export const initialLocationChanged = createAction(INITIAL_LOCATION_CHANGED)

export const initialLocationHasUtmParams = createAction(INITIAL_LOCATION_HAS_UTM_PARAMS)

/**
 * Some components use 'now'/'today'/`new Date()` in their rendering. The following can occur:
 *
 * 1. SSR renders page with `It's 3:05pm on Tuesday` in the text of the page
 * 2. Fastly caches that for (say) 8 hours
 * 3. Client loads the 8-hour-old page and tries to change to change the text to `It's 11:05pm on Tuesday`
 *    duration hydration. That throws a hydration error
 *
 * To avoid those types of errors, we stick the result of `Date.now()` into redux. This allows SSR and CSR
 * to be in-sync, and we `dispatch(updateNow())` at appropriate times to keep the UI fresh.
 */
export const updateNow = createAction(UPDATE_NOW)
